import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@shared/ui';
import { finalize } from 'rxjs';

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const loadingService = inject(LoadingService);

  const LOADING_URLS = [
    '/auth/login',
    '/auth/myself',
    '/driver/list',
    '/order/list/noCache',
    '/user/list',
    '/vehicle/list',
    '/map',
    '/driver/generate/pin',
  ] as const;

  const EXCLUDED_URLS = [
    '/order/point/approve/list',
    '/order/finish',
    '/driver/generate/pin',
  ] as const;

  const isApiCall = req.url.includes('/api');
  const shouldShowLoading = LOADING_URLS.some((url) => req.url.includes(url));
  const isExcluded = EXCLUDED_URLS.some((url) => req.url.includes(url));

  if (isApiCall && (!shouldShowLoading || isExcluded)) {
    return next(req);
  }

  loadingService.show();

  return next(req).pipe(finalize(() => loadingService.hide()));
};
